export default "__VITE_ASSET__Cd$Okc$f__"